import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { WorkExperience } from '../model/WorkExperience';


@Component({
    selector: 'app-work-experience',
    templateUrl: './workExperience.component.html',
    styleUrls: ['./workExperience.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkExperienceComponent implements OnInit {

  @Input() readonly = false;
  @Input() touched = false;
  @Input() workExperience!: WorkExperience;
  @Input() index = 0;
  @Output() changed = new EventEmitter();
  today = new Date();

  constructor() { }

  ngOnInit() {
  }


}
